import { debug } from './debug';

// Deep link handler utility
export const DeepLinkHandler = {
  // Parse URL parameters
  parseUrlParams: (url) => {
    try {
      const params = new URLSearchParams(url.split('?')[1]);
      return {
        type: params.get('type'),
        id: params.get('id')
      };
    } catch (error) {
      debug.error('Error parsing URL parameters:', error);
      return null;
    }
  },

  // Handle deep link
  handleDeepLink: (url) => {
    const params = DeepLinkHandler.parseUrlParams(url);
    if (!params) return null;

    switch (params.type) {
      case 'openproposal':
        console.log('DeepLinkHandler handleDeepLink openproposal', params.id);
        return {
          type: 'openproposal',
          proposalId: params.id
        };
      default:
        return null;
    }
  },

  // Check if current URL is a deep link
  checkCurrentUrl: () => {
    const url = window.location.href;
    // Handle both custom scheme and web URLs
    console.log('DeepLinkHandler checkCurrentUrl', url);
    if (url.startsWith('didema://') || url.includes('/openproposal/action')) {
      return DeepLinkHandler.handleDeepLink(url);
    }
    return null;
  },

  // Create deep link URL
  createDeepLink: (type, id) => {
    return `didema://action?type=${type}&id=${id}`;
  },

  // Create web URL
  createWebLink: (type, id) => {
    return `https://didema.com/action?type=${type}&id=${id}`;
  },

  // Store navigation intent
  storeNavigationIntent: (intent) => {
    if (intent) {
      sessionStorage.setItem('navigationIntent', JSON.stringify(intent));
    } else {
      sessionStorage.removeItem('navigationIntent');
    }
  },

  // Get stored navigation intent
  getNavigationIntent: () => {
    const stored = sessionStorage.getItem('navigationIntent');
    return stored ? JSON.parse(stored) : null;
  },

  // Clear stored navigation intent
  clearNavigationIntent: () => {
    sessionStorage.removeItem('navigationIntent');
  }
}; 